import { getPageRouteFromPathname, stripDarkFromRoute, getDocumentLocation } from '@nike/ux-tread-dotcom-utils';
export default (function () {
  var _getDocumentLocation = getDocumentLocation(),
    pathname = _getDocumentLocation.pathname;
  return stripDarkFromRoute(getPageRouteFromPathname(pathname));
});